// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"1c4f91f3","492":"90fadbed","787":"4e17fdac","997":"9c7ccba8"}[chunkId] + ".chunk.js";
};